import React, { ButtonHTMLAttributes, useEffect, useState } from 'react';
import LoadingDots from '../../LoadingDots';
import { Checkmark, Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  success?: boolean;
};

const PrimaryButton: React.FC<ButtonProps> = ({
  children,
  loading,
  success,
  ...rest
}) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      setShowSuccess(true);
      const timer = setTimeout(() => setShowSuccess(false), 1000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [success]);

  return (
    <Container
      className={`primary-button ${loading ? 'loading' : ''}`}
      $success={showSuccess}
      {...rest}
    >
      {(() => {
        if (loading) {
          return <LoadingDots />;
        }
        if (showSuccess) {
          return (
            <Checkmark viewBox="0 0 24 24">
              <path fill="none" d="M4.1 12.7L9 17.6 20.3 6.3" />
            </Checkmark>
          );
        }
        return children;
      })()}
    </Container>
  );
};

export default PrimaryButton;
